import { render, staticRenderFns } from "./PersonalCard.vue?vue&type=template&id=4c460076&scoped=true&"
import script from "./PersonalCard.vue?vue&type=script&lang=js&"
export * from "./PersonalCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCard.vue?vue&type=style&index=0&id=4c460076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c460076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCol,VDivider,VImg,VProgressCircular,VRow})
